import { styled as n, Box as e } from "@mui/joy";
import { excludeForwardProps as t } from "../../../utils/excludeForwardProps.js";
const a = n(e, { shouldForwardProp: t("focus") })(({ theme: n2, focus: e2 }) => `
  .k-input.k-datepicker {
    border-radius: ${n2.radius.sm};
    box-shadow: ${n2.palette.isDarkMode ? "none" : "var(--joy-shadowRing, 0 0 #000),0px 1px 2px 0px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08))"};
    border: 1px solid ${n2.palette.isDarkMode ? n2.palette.neutral[250] : "var(--variant-outlinedBorder, var(--joy-palette-neutral-outlinedBorder, var(--joy-palette-neutral-300, #CDD7E1)))"};
    padding-inline: var(--Input-paddingInline);
    padding-right: 2px;
    background: ${n2.palette.isDarkMode ? n2.palette.neutral[150] : "var(--joy-palette-background-surface)"};
    height: 36px;
    color: ${n2.palette.isDarkMode ? n2.palette.neutral[500] : "inherit"};

    &:focus-within {
      border-color: ${n2.palette.primary.solidBg};
    }

    &:disabled,
    &.k-disabled {
      opacity: ${n2.palette.isDarkMode ? 0.6 : 0.7};
      background: ${n2.palette.isDarkMode ? n2.palette.neutral[100] : "var(--joy-palette-background-surface)"};
    }

    &.k-disabled .k-dateinput .k-input-inner {
      opacity: ${n2.palette.isDarkMode ? 0.7 : 0.8};
      color: ${n2.palette.isDarkMode ? n2.palette.neutral[400] : "inherit"};
    }
    
    &.k-invalid {
      border-color: rgb(240, 152, 152);
      
      .k-dateinput .k-input-inner {
        color: rgb(240, 152, 152);
      }
      
      .k-dateinput.k-focus .k-input-inner {
        color: rgb(196, 28, 28);
      }
    }
    
    ${e2 ? "\n      &.k-invalid {\n        border-color: rgb(196, 28, 28);\n      }\n    " : ""}
  }

  .k-input-md .k-input-inner {
    padding-inline: 12px;
    color: ${n2.palette.isDarkMode ? n2.palette.neutral[500] : "inherit"};
    background: transparent;
  }

  .k-icon,
  .k-button-icon {
    color: ${n2.palette.isDarkMode ? n2.palette.neutral[500] : "inherit"};
  }
  .MuiSvgIcon-root path {
    fill: ${n2.palette.isDarkMode ? n2.palette.neutral[400] : "inherit"};
  }
  .MuiDateCalendar-root {
          background-color: ${n2.palette.isDarkMode ? n2.palette.neutral[100] : "var(--joy-palette-background-surface)"};
  }
`);
export {
  a as Wrapper
};
//# sourceMappingURL=styled.js.map
